<template>
    <div class="sector-bar-chart">
      <!-- Cabeçalho do gráfico -->
      <v-card flat class="mb-4">
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="primary">mdi-chart-bar</v-icon>
          <span class="text-h5 font-weight-bold">Performance por Setor</span>
          <v-spacer />
          <v-chip size="small" color="info">
            {{ setoresComDados.length }} setores ativos
          </v-chip>
        </v-card-title>
      </v-card>
  
      <!-- Gráfico ApexCharts -->
      <apexchart
        type="bar"
        :options="chartOptions"
        :series="chartSeries"
        height="360"
      />
    </div>
  </template>
  
  <script>
  import { computed } from 'vue'
  
  export default {
    name: 'SectorBarChart',
    props: {
      setores: {
        type: Array,
        required: true
      }
    },
    setup(props) {
      // Agrupa apenas por nome_setor
      const setoresComDados = computed(() => {
        const map = {}
        props.setores.forEach(s => {
          const key = s.nome_setor
          if (!map[key]) {
            map[key] = { nome_setor: key, planejado: 0, produzido: 0 }
          }
          map[key].planejado += Number(s.planejada_inicial || 0)
          map[key].produzido  += Number(s.produzida || 0)
        })
        return Object.values(map)
      })
  
      // Série de dados
      const chartSeries = computed(() => [
        {
          name: 'Planejado',
          data: setoresComDados.value.map(s => s.planejado)
        },
        {
          name: 'Produzido',
          data: setoresComDados.value.map(s => s.produzido)
        },
        {
          name: 'Falta',
          data: setoresComDados.value.map(s => s.planejado - s.produzido)
        }
      ])
  
      // Opções de estilo
      const chartOptions = computed(() => ({
        chart: {
          background: '#f9f9f9',
          dropShadow: { enabled: true, top: 4, left: 2, blur: 4, opacity: 0.1 },
          toolbar: { show: false },
          fontFamily: 'Roboto, sans-serif',
          foreColor: '#212121'
        },
        title: { text: undefined },
        plotOptions: {
          bar: { horizontal: false, columnWidth: '60%', borderRadius: 6 }
        },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.3,
            gradientToColors: ['#1976D2', '#4CAF50', '#FFC107'],
            inverseColors: false,
            opacityFrom: 0.9,
            opacityTo: 0.7,
            stops: [0, 100]
          }
        },
        xaxis: {
          categories: setoresComDados.value.map(s => s.nome_setor),
          title: { text: 'Setor', style: { fontSize: '14px', fontWeight: 600, color: '#212121' } },
          labels: { rotate: -45, style: { fontSize: '12px', colors: '#555' } }
        },
        yaxis: {
          title: { text: 'Quantidade', style: { fontSize: '14px', fontWeight: 600, color: '#212121' } },
          labels: { style: { fontSize: '12px', colors: '#555' } }
        },
        grid: { borderColor: '#e0e0e0', strokeDashArray: 4 },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          labels: { colors: '#555', useSeriesColors: false },
          fontSize: '14px',
          fontWeight: 500
        },
        // Aqui definimos as cores fixas para cada série:
        colors: ['#1976D2', '#4CAF50', '#FFC107'],
        tooltip: { theme: 'light' },
        responsive: [
          {
            breakpoint: 600,
            options: {
              plotOptions: { bar: { columnWidth: '80%' } },
              xaxis: { labels: { rotate: -90 } }
            }
          }
        ]
      }))
  
      return { setoresComDados, chartSeries, chartOptions }
    }
  }
  </script>
  
  <style scoped>
  .sector-bar-chart {
    background: #ffffff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  }
  </style>
  